import { useState } from 'react';
import * as yup from 'yup';

import { importNanoid } from '@/utility/helpers';
import { t } from '@/utility/localization';
import { addPrefixToUrlIfRequired } from '@/utility/urlHelpers';
import { urlWithoutProtocolRegex } from '@/utility/validation';

import { FILE_TYPE } from '@/contexts/LibrarySetupContext/constants';

import { showErrorToast } from '@/components/common/ToastContainer';

export const isValidUrl = ({ url }) => {
  if (!url) return false;

  let schema = yup.string().matches(urlWithoutProtocolRegex);
  return schema.isValidSync(url);
};

const useUrlList = () => {
  const [urlList, setUrlList] = useState([]);

  const addUrl = ({ url, callback }) => {
    if (!url) return;

    // check comma and new line
    const urlSplitList = url.replace(/\r?\n/g, ',').split(',');
    const hasMultipleItem = urlSplitList.length > 1;
    const { nanoid } = importNanoid();

    // if multiple list one by one
    if (hasMultipleItem) {
      const formattedUrlSplitList = urlSplitList.reduce((acc, url) => {
        if (!url) return acc;

        if (!isValidUrl({ url })) {
          showErrorToast(t('invalid-url'));

          return acc;
        }

        acc.push({
          id: nanoid(),
          link: addPrefixToUrlIfRequired(url.trim()),
          type: FILE_TYPE.EXTERNAL_LINK
        });

        return acc;
      }, []);

      setUrlList((prev) => {
        return [...prev, ...formattedUrlSplitList];
      });

      callback();
      return;
    }

    if (!isValidUrl({ url })) {
      showErrorToast(t('invalid-url'));
      return;
    }

    setUrlList((prev) => {
      return [
        ...prev,
        {
          id: nanoid(),
          link: addPrefixToUrlIfRequired(url.trim()),
          type: FILE_TYPE.EXTERNAL_LINK
        }
      ];
    });
    callback();
  };

  const deleteUrl = ({ id }) => {
    const filteredUrlList = urlList.filter((url) => url.id !== id);

    setUrlList(filteredUrlList);
  };

  return { urlList, addUrl, deleteUrl };
};

export default useUrlList;
